<div style="background-color: #A00000; color: white;">
    <app-page-breadcrumb [isModal]="isModal"
        [pageInfo]="{title : 'Prescription Details',buttonShowBtn : true,button :{title : '', url :'',icon : 'las la-times', color: 'light'}}"></app-page-breadcrumb>
</div>

<div class="modal-body card pt-3">
    <div class="mb-2">
        <div class="row clearfix m-2" [hidden]="dataLoading">
            <div class="col-lg-12 col-md-12 col-xl-12">
                <info-view [formData]="prescriptionFormData" [sourceData]="prescriptionData"></info-view>
            </div>
        </div>
        <h6>Medicines </h6>
        <div *ngIf="medicineList.length" class="row clearfix m-2" [hidden]="dataLoading">
            <app-table-list #tableData [tableConfig]="tableConfig" [parentGetList]="getMedicineData">
            </app-table-list>
        </div>
        <div class="row clearfix text-center mt-2" [hidden]="dataLoading">
            <div class="col-12">
                <button [disabled]="dataLoading" (click)="close()" class="btn ml-1 btn-round btn-danger">Close</button>
            </div>
        </div>
        <app-page-loader [loading]="dataLoading"></app-page-loader>
    </div>
</div>